module.exports = __webpack_public_path__ + "img/video-51sx-2024.599e2d2f.png";